"use strict";

var React = require('react');

var path = require('path');

var _require = require('./contexts/translate-context'),
    TranslateProvider = _require.TranslateProvider;

var _require2 = require('./contexts/translated-routes-context'),
    TranslatedRoutesProvider = _require2.TranslatedRoutesProvider;

exports.wrapPageElement = function (_ref) {
  var element = _ref.element,
      props = _ref.props;
  var translateState = {
    language: props.pageContext.language,
    isSourceLanguage: props.pageContext.isSourceLanguage,
    staticTranslations: props.pageContext.staticTranslations,
    originalPath: props.pageContext.originalPath,
    currentPath: props.pageContext.currentPath
  };
  return /*#__PURE__*/React.createElement(TranslateProvider, {
    translateState: translateState
  }, element);
};

exports.wrapRootElement = function (_ref2) {
  var element = _ref2.element;

  var translatedRoutes = require(path.dirname(require.main.path) + "/translatedRoutes.json");

  return /*#__PURE__*/React.createElement(TranslatedRoutesProvider, {
    translatedRoutes: translatedRoutes
  }, element);
};